import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule} from '@angular/common';
import { MaterialModule } from '../../app-material.module';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem
} from "@angular/cdk/drag-drop";

//* Defined constants
const PAGINATION_DEFAULT_SIZE = 10;

@Component({
  selector: 'app-assemblea-approvazione',
  templateUrl: './assemblea-approvazione.component.html',
  styleUrls: ['./assemblea-approvazione.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, CdkDrag, CdkDropList, CdkDropListGroup]
})
export class AssembleaApprovazioneDialog implements OnInit {
  profiles: any[] = [];
  skills: any[] = [];
  selectedProfiles: any[] = [];
  selectedSkills: any[] = [];


  constructor(
    public dialogRef: MatDialogRef<AssembleaApprovazioneDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public api: HttpService,
    private snackBar: MatSnackBar
  ) {}

  get disableSubmitButton(){
    return !this.selectedSkills.length && !this.selectedProfiles.length;
  }

  get paginationSize(){
    return PAGINATION_DEFAULT_SIZE;
  }

  get skillsPagination(){
    return Math.trunc(this.skills.length / PAGINATION_DEFAULT_SIZE);
  }

  ngOnInit(): void {


    this.api.getProfiliAssegnati(this.data.element.id)
      .subscribe({
        next: (response: any) => {
          this.profiles = response.result;
      }});

    this.api.getCompetenzeAssegnateAssemblea(this.data.element.id)
    .subscribe({
        next: (response: any) => {
          this.skills = response.result;
    }});

  }

  onPaginateChange(event : any){
    // console.log('pagination change', event);
  }

  drop(event: CdkDragDrop<string[]>) {
    let idx = event.container.data.indexOf(event.previousContainer.data[event.previousIndex]);
    if (idx != -1) {
      return;//if item exist
    }


    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  approveAllSkills(){
    this.selectedSkills = [...this.skills];
    this.skills = [];
  }

  unapproveAllSkills(){
    this.skills = [...this.selectedSkills];
    this.selectedSkills = [];
  }

  approveAllProfiles(){
    this.selectedProfiles = [...this.profiles];
    this.profiles = [];
  }

  unapproveAllProfiles(){
    this.profiles = [...this.selectedProfiles];
    this.selectedProfiles = [];
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    const payload = {
      id: this.data.element.id,
      listaProfili: this.selectedProfiles,
      listaCompetenze: this.selectedSkills
    };

    this.api.confermaAssemblea(payload).subscribe({
      next: () => {
        this.snackBar.open('Approvazione confermata', 'Chiudi', { duration: 2000 });
        this.dialogRef.close();
      },
      error: (err) => {
        console.error('Errore durante la conferma dell\'assemblea', err);
        this.snackBar.open('Errore durante la conferma', 'Chiudi', { duration: 2000 });
      }
    });
  }

}
